import { loadScript } from '@/js/helpers/scripts'
import type { IRogue } from '@/js/services/RogueTypes'

// submits an action to captcha for evaluation,
// and returns a token, our siteKey, and expectedAction for assessment creation
export async function generateCaptchaToken(action: string, rogue: IRogue): Promise<string> {
  let token = ''
  try {
    if (rogue.keys.recaptchaSiteKey) {
      await loadScript('recaptcha', rogue)

      const recaptcha = window.grecaptcha
      if (recaptcha) {
        await new Promise((resolve) => recaptcha.enterprise.ready(() => resolve(true)))
        token = await recaptcha.enterprise.execute(rogue.keys.recaptchaSiteKey, { action })
      } else {
        throw new Error('Cannot load recaptcha')
      }
    }
  } catch (e) {
    const error = e as Error
    rogue.log.warn(`Unable to generate captcha token: ${error.message}`)
  }

  return token
}
